import firebase from "../../../../../../firebase/firebase";

export default function({ officeId, visitId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "endVisit",
        data: { officeId, visitId }
    });
}
